module.exports = __webpack_public_path__ + "static/media/section-reporting.f2c9a6fd.svg";